module.exports = __webpack_public_path__ + "static/media/GT08_GT_Additional-Services.41d01f00.csv";